import LoadingButton from '@mui/lab/LoadingButton'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

import { useDeleteProspectsMutation } from '../slice'

const DeleteConfirmDialog = ({ prospectIds, campaignId, open, setOpen }) => {
  const [deleteProspects, { isLoading }] = useDeleteProspectsMutation()

  const handleClose = () => {
    setOpen(false)
  }

  const handleDelete = async () => {
    await deleteProspects({ prospectIds })
    setOpen(false)
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{`Permanently delete prospects?`}</DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          You are about to delete {prospectIds.length} prospect(s) from the database. Are you sure you want to do this?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <LoadingButton disabled={isLoading} onClick={handleClose} autoFocus>
          Cancel
        </LoadingButton>
        <LoadingButton color="error" loading={isLoading} onClick={handleDelete}>
          Remove
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteConfirmDialog
